module.exports = __webpack_public_path__ + "static/map-b158df6ff50a5abc150de532f4a2d17f.webm";